<template>
    <div class="pure-g friendsList">

        <template v-if="myFriends.length > 0">

            <template v-for="(member, memberIndex) in myFriends">
                <div
                    :key="memberIndex"
                    class="pure-u-1-2 pure-u-lg-1-4 friendItem"
                >
                    <router-link :to="`/user/${$store.state.allUsers[member.id].uid}`" class="friendItemLink">
                        <div class="inner">
                            <div class="image" :style="`background-image:url(${$store.state.allUsers[member.id].photoURL + '?width=500&height=500'});`"></div>
                            <div class="content">
                                <p class="name mb-1">{{ $store.state.allUsers[member.id].displayName }}</p>

                                <p class="location mb-1" v-if="typeof($store.state.allUsers[member.id].location) !== 'undefined' ? typeof($store.state.allUsers[member.id].location.city) !== 'undefined' : false">
                                    {{ $store.state.allUsers[member.id].location.city.name }},
                                    {{ $store.state.allUsers[member.id].location.state.name }}
                                </p>

                                <p class="title">
                                    <span v-if="$store.state.allUsers[member.id].displayName === 'Anand Davaasuren'" class="badge staff">Organizer</span>
                                    <span v-else-if="$store.state.allUsers[member.id].isStaff" class="badge staff">{{ $store.state.allUsers[member.id].staffTitle }}</span>
                                    <span v-else-if="$store.state.allUsers[member.id].isMember" class="badge yellow">Member</span>
                                    <span v-else class="badge grey">User</span>
                                </p>
                            </div>
                        </div>
                    </router-link>
                </div>
            </template>
        
        </template>
        <template v-else>
            <div class="pure-u-1">
                <p class="empty">No friends here yet.</p>
            </div>
        </template>

    </div>
</template>

<script>
export default {
    name: 'Friends',

    props: {
        uid: String
    },

    data(){
        return{
            allFriends: []
        }
    },

    async mounted(){
        await this.$bind('allFriends', this.$firebase.firestore().collection('users').doc(this.uid).collection('friends').orderBy('timestamp', 'asc'))
    },

    computed: {
        myFriends(){
            return this.allFriends.filter(friend => {
                if(friend.isFriends === true && friend.status === 'friends'){
                    return friend
                }
            })
        },
        friendsCount(){
            let allFriends = this.allFriends.filter(friend => {
                if(friend.isFriends === true && friend.status === 'friends'){
                    return friend
                }
            })
            return allFriends.length
        },
        myFriendRequestsSent(){
            return this.allFriends.filter(friend => {
                if(friend.isFriends === false && friend.status === 'friendRequestSent'){
                    return friend
                }
            })
        },
        myFriendRequestsReceived(){
            return this.allFriends.filter(friend => {
                if(friend.isFriends === false && friend.status === 'friendRequestReceived'){
                    return friend
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/user/Friends.vue